import { decodeBase64 } from './base64';

const loadSindico = () => {
  const sindicoToken = sessionStorage.getItem('sindico');

  if (sindicoToken) {
    return decodeBase64(sindicoToken);
  }

  return null;
};

export default loadSindico;
